export class NumberUtils {
  static humanReadableFileSize(size: number): string {
    const i = Math.floor(Math.log(size) / Math.log(1024));
    const fixed = (size / Math.pow(1024, i)).toFixed(2);
    return `${fixed} ${['B', 'kB', 'MB', 'GB', 'TB'][i]}`;
  }
}
